import React from "react";
import Button from "react-bootstrap/Button";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter
} from "mdb-react-ui-kit";

import "./PopConfirm.css";

export class PopConfirm extends React.Component {

  setShow(event) {
    if (this.props.show !== event) {
      if (!event && typeof this.props.onCancel === 'function') {
        this.props.onCancel();
      }
    }
  }

  confirm() {
    this.props.onConfirm();
  }

  cancel() {
    if (typeof this.props.onCancel === 'function') {
      this.props.onCancel();
    }
  }

  render() {
    return (
      <>
        <MDBModal
          show={this.props.show}
          setShow={(event) => this.setShow(event)}
          tabIndex="-1"
        >
          <MDBModalDialog size="lg">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>{this.props.title}</MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={() => this.cancel()}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <p>{this.props.detail}</p>
              </MDBModalBody>
              <MDBModalFooter>
                <Button onClick={() => this.cancel()} variant="outline-danger">
                  Cancelar
                </Button>
                <Button
                  onClick={() => this.confirm()}
                  variant="outline-success"
                >
                  Confirmar
                </Button>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </>
    );
  }
}
